import React, { useState } from 'react';
import { NavigationBar } from './components/NavigationBar';
import Dashboard from './components/Dashboard';
export function App() {
  return <div className="flex flex-col w-full min-h-screen bg-[#f5f6f8]" data-id="element-0">
      <NavigationBar data-id="supply-chain-nav" />
      <Dashboard data-id="element-1" />
    </div>;
}